import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	sectionMessageBody: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	sectionMessageBodyWhenToggleOff: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	sectionMessageLearnMore: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	sectionMessageLearnMoreWhenToggleOff: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	sectionMessageBodyIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	sectionMessageBodyWhenToggleOffIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	sectionMessageLearnMoreWhenToggleOffIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	sectionMessageBody: {
		id: 'issue-create.modal.jsm-request-type-fields-changeboarding.section-message-body',
		defaultMessage:
			'Since a request type has been selected for this issue, these fields can’t be edited here.',
		description:
			'Body text - for an atlaskit SectionMessage that appears on the "Show Fields" modal, explaining to users that we have removed the "Custom fields" option',
	},
	sectionMessageBodyWhenToggleOff: {
		id: 'issue-create.modal.jsm-request-type-fields-changeboarding.section-message-body-when-toggle-off',
		defaultMessage:
			'Turn on the <bold>Use request type fields</bold> toggle to see only request type fields while creating issues.',
		description:
			'Body text - for an atlaskit SectionMessage that appears on the "Show Fields" modal, explaining to users that we have removed the "Custom fields" option. ' +
			"This message variation is used when the 'Use request type fields' user preference is off. " +
			"The toggle title is defined in message id 'issue-create.modal.create-form.request-type-fields-layout-preference.toggle-label'.",
	},
	sectionMessageLearnMore: {
		id: 'issue-create.modal.jsm-request-type-fields-changeboarding.section-message-learn-more',
		defaultMessage: 'Learn more about editing the fields of a request type',
		description:
			'Learn more link text to a documentation page explaining how to customise the fields of a request type - for an atlaskit SectionMessage that appears on the "Show Fields" modal, explaining to users that we have removed the "Custom fields" option',
	},
	sectionMessageLearnMoreWhenToggleOff: {
		id: 'issue-create.modal.jsm-request-type-fields-changeboarding.section-message-learn-more-when-toggle-off',
		defaultMessage: 'Learn more about using request type fields while creating issues',
		description:
			'Learn more link text to a documentation page explaining how to customise the fields of a request type - for an atlaskit SectionMessage that appears on the "Show Fields" modal, explaining to users that we have removed the "Custom fields" option ' +
			"This message variation is used when the 'Use request type fields' user preference is off.",
	},
	sectionMessageBodyIssueTermRefresh: {
		id: 'issue-create.modal.jsm-request-type-fields-changeboarding.section-message-body-issue-term-refresh',
		defaultMessage:
			'Since a request type has been selected for this work item, these fields can’t be edited here.',
		description:
			'Body text - for an atlaskit SectionMessage that appears on the "Show Fields" modal, explaining to users that we have removed the "Custom fields" option',
	},
	sectionMessageBodyWhenToggleOffIssueTermRefresh: {
		id: 'issue-create.modal.jsm-request-type-fields-changeboarding.section-message-body-when-toggle-off-issue-term-refresh',
		defaultMessage:
			'Turn on the <bold>Use request type fields</bold> toggle to see only request type fields while creating work items.',
		description:
			'Body text - for an atlaskit SectionMessage that appears on the "Show Fields" modal, explaining to users that we have removed the "Custom fields" option. ' +
			"This message variation is used when the 'Use request type fields' user preference is off. " +
			"The toggle title is defined in message id 'issue-create.modal.create-form.request-type-fields-layout-preference.toggle-label'.",
	},
	sectionMessageLearnMoreWhenToggleOffIssueTermRefresh: {
		id: 'issue-create.modal.jsm-request-type-fields-changeboarding.section-message-learn-more-when-toggle-off-issue-term-refresh',
		defaultMessage: 'Learn more about using request type fields while creating work items',
		description:
			'Learn more link text to a documentation page explaining how to customise the fields of a request type - for an atlaskit SectionMessage that appears on the "Show Fields" modal, explaining to users that we have removed the "Custom fields" option ' +
			"This message variation is used when the 'Use request type fields' user preference is off.",
	},
});
export default messages;
